import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Card, Table, Button, Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import {
    GIAYPHEPHANHNGHE_API,
    CHUNGCHI_CHUYENMON_API,
    BaseGatewayImage,
    ACCOUNT_API
} from '@app/utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { getUser } from '@app/utils/oidc';
import { getRoleUser } from '@app/utils/httpClient';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import { role } from '@app/utils/define';

const formatDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('vi-VN');
};

const formatNoiCap = (value) => {
    if (!value) return '-';
    const strValue = String(value).trim();
    switch (strValue) {
        case 'boYTe': return 'Bộ Y tế';
        case 'boQuocPhong': return 'Bộ Quốc phòng';
        case 'soYTe': return 'Sở Y tế';
        case 'khac': return 'Khác';
        default: return value;
    }
};

const formatTrangThai = (status) => {
    if (status === null || status === undefined || status === '') {
        return { label: 'Chưa cập nhật', color: 'bg-secondary' };
    }
    const strStatus = String(status).toLowerCase().trim();
    switch (strStatus) {
        case '0':
        case 'nhaplieu': return { label: 'Nhập liệu', color: 'bg-secondary' };
        case '1':
        case 'choduyet': return { label: 'Chờ duyệt', color: 'bg-warning text-dark' };
        case '2':
        case 'daduyet': return { label: 'Đã duyệt', color: 'bg-success' };
        case '3':
        case 'phuhop':
        case 'phù hợp': return { label: 'Phù hợp', color: 'bg-success' };
        case '4':
        case 'khongphuhop':
        case 'không phù hợp': return { label: 'Không phù hợp', color: 'bg-danger' };
        default: return { label: 'Chờ duyệt', color: 'bg-warning text-dark' };
    }
};

const GiayPhepHanhNghe = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    // State quản lý phân quyền
    const [hasAccess, setHasAccess] = useState(false);
    const [isCheckingRole, setIsCheckingRole] = useState(true);

    // State quản lý Modal Confirm gửi xác nhận
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [idWantConfirm, setIdWantConfirm] = useState('');

    // Kiểm tra quyền truy cập ngay khi component mount
    useEffect(() => {
        const checkUserRole = async () => {
            try {
                const roles = await getRoleUser();
                let normalizedRoles = [];

                if (typeof roles === 'string') {
                    normalizedRoles = [roles.toLowerCase()];
                } else if (Array.isArray(roles)) {
                    normalizedRoles = roles.map(r => r.toLowerCase());
                }

                // Check quyền (cho phép app_giayphephanhnghe_access hoặc admin)
                if (normalizedRoles.includes(role.APP_GIAYPHEPHANHNGHE_ACCESS) || normalizedRoles.includes(role.Admin)) {
                    setHasAccess(true);
                } else {
                    setHasAccess(false);
                }
            } catch (error) {
                console.error('Lỗi khi kiểm tra quyền:', error);
                setHasAccess(false);
            } finally {
                setIsCheckingRole(false);
            }
        };

        checkUserRole();
    }, []);

    const fetchProfileData = async () => {
        const user = await getUser();
        if (!user?.profile?.sub) return null;
        const accountId = user.profile.sub;

        try {
            const [gphnRes, cccmRes, accountRes, accountCommonRes] = await Promise.all([
                Get(`${GIAYPHEPHANHNGHE_API.GET_ACCOUNT_INFO_ID}/${accountId}`),
                Get(`${CHUNGCHI_CHUYENMON_API.GET_BY_ACCOUNT_INFO_ID}/${accountId}`),
                Get(`${ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG}/${accountId}`),
                Get(`${ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG}/${accountId}`),
            ]);

            const chucDanhRes = accountRes?.doiTuong?.tenDoiTuong || accountRes?.data?.doiTuong?.tenDoiTuong || '';
            const chucDanhChuyenMonRes = accountRes?.chucDanhChuyenMon?.tenDoiTuong || accountRes?.data?.chucDanhChuyenMon?.tenDoiTuong || '';
            const rawGphns = gphnRes?.data?.$values || gphnRes?.data || gphnRes || [];
            const rawCccms = cccmRes?.data?.$values || cccmRes?.data || cccmRes || [];

            const gphns = Array.isArray(rawGphns) ? rawGphns : [rawGphns].filter(Boolean);
            const cccms = Array.isArray(rawCccms) ? rawCccms : [rawCccms].filter(Boolean);
            const hoTen = [accountCommonRes?.lastName, accountCommonRes?.middleName, accountCommonRes?.firstName]
                .filter(Boolean)
                .join(' ');

            let fetchedXacNhanStatus = null;
            let fetchedLyDo = null;
            const giayPhepId = gphns[0]?.id || gphns[0]?.Id;
            if (giayPhepId) {
                try {
                    const duyetRes = await Get(`${GIAYPHEPHANHNGHE_API.GET_BY_GIAYPHEP_ID}/${giayPhepId}`);
                    const duyetData = duyetRes?.data || duyetRes;
                    fetchedXacNhanStatus = duyetData?.xacNhanDuyet || duyetData?.XacNhanDuyet || null;
                    fetchedLyDo = duyetData?.lyDo || duyetData?.LyDo || null;
                } catch (err) { }
            }

            return {
                name: hoTen,
                gphns: gphns,
                cccms: cccms,
                xacNhanStatus: fetchedXacNhanStatus,
                lyDo: fetchedLyDo,
                chucDanh: chucDanhRes,
                chucDanhChuyenMon: chucDanhChuyenMonRes
            };
        } catch (error) {
            console.error('Lỗi lấy dữ liệu hồ sơ:', error);
            throw error;
        }
    };

    const { isLoading, isError, error, data: profileData, refetch } = useQuery(
        ['giayPhepHanhNgheProfile'],
        fetchProfileData,
        {
            enabled: hasAccess, // Chỉ gọi API khi user ĐÃ có quyền truy cập
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            cacheTime: 0
        }
    );

    const handleOpenFile = (path) => {
        if (path) {
            window.open(`${BaseGatewayImage}${path}`, '_blank');
        }
    };

    // Mở modal xác nhận
    const openConfirmGuiXacNhan = (id) => {
        setIdWantConfirm(id);
        setOpenConfirmModal(true);
    };

    // Hủy gửi xác nhận
    const cancelGuiXacNhan = () => {
        setIdWantConfirm('');
        setOpenConfirmModal(false);
    };

    // Đồng ý gửi xác nhận
    const acceptGuiXacNhan = async () => {
        if (!idWantConfirm) return;

        try {
            setIsSubmitting(true);
            setOpenConfirmModal(false); // Tắt modal ngay sau khi bấm đồng ý

            const payloadGPHN = { id: idWantConfirm, fieldName: 'TrangThai', value: "Chờ duyệt" };
            await Put(`${GIAYPHEPHANHNGHE_API.UPDATE_FIELD}`, null, payloadGPHN);

            const duyetRes = await Get(`${GIAYPHEPHANHNGHE_API.GET_BY_GIAYPHEP_ID}/${idWantConfirm}`);
            const duyetData = duyetRes?.data || duyetRes;

            const payload = { id: duyetData.id, fieldName: 'XacNhanDuyet', value: "Chờ duyệt" };
            await Put(`${GIAYPHEPHANHNGHE_API.UPDATE_FIELD_DSDHS}`, null, payload);

            toast.success('Đã gửi xác nhận hồ sơ thành công!');
            await refetch();
        } catch (err) {
            console.error('Lỗi khi gửi xác nhận:', err);
            toast.error('Có lỗi xảy ra khi gửi xác nhận.');
        } finally {
            setIsSubmitting(false);
            setIdWantConfirm('');
        }
    };

    // Rendering trạng thái loading khi check quyền
    if (isCheckingRole) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-2 text-muted">Đang kiểm tra quyền truy cập...</span>
            </div>
        );
    }

    // Rendering màn hình từ chối truy cập nếu không có quyền
    if (!hasAccess) {
        return (
            <div className="container-fluid mt-5">
                <Card className="text-center p-5 shadow-sm border-0 mx-auto" style={{ maxWidth: '600px' }}>
                    <Card.Body>
                        <i className="fas fa-lock text-danger mb-3" style={{ fontSize: '4rem' }}></i>
                        <h4 className="text-danger fw-bold mt-2">Truy cập bị từ chối</h4>
                        <p className="text-muted">Bạn không có quyền truy cập vào trang này. Yêu cầu quyền <strong>app_giayphephanhnghe_access</strong>.</p>
                        <Button variant="outline-secondary" onClick={() => window.history.back()}>
                            <i className="fas fa-arrow-left me-2"></i> Quay lại
                        </Button>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    const currentStatusStr = String(profileData?.xacNhanStatus || '').toLowerCase().trim();
    const hideSubmitButton = ['1', 'choduyet', 'chờ duyệt', '2', 'daduyet', 'đã duyệt', '3', 'phuhop', 'phù hợp', '4', 'khongphuhop', 'không phù hợp'].includes(currentStatusStr);

    const getPvhnList = (g) => {
        if (Array.isArray(g.phamViHanhNgheNames) && g.phamViHanhNgheNames.length > 0) return g.phamViHanhNgheNames;
        if (Array.isArray(g.PhamViHanhNgheNames) && g.PhamViHanhNgheNames.length > 0) return g.PhamViHanhNgheNames;
        const listPvhn = g.phamViHanhNghes || g.PhamViHanhNghes || g.listPhamViHanhNghe;
        if (Array.isArray(listPvhn) && listPvhn.length > 0) return listPvhn.map(x => x.tenPhamViHanhNghe || x.TenPhamViHanhNghe || x.name || x.Name || '').filter(Boolean);
        const strOrArr = g.tenPhamViHanhNghe ?? g.TenPhamViHanhNghe ?? g.phamViHanhNghe ?? g.PhamViHanhNghe;
        return Array.isArray(strOrArr) ? strOrArr : (strOrArr ? [strOrArr] : []);
    };

    return (
        <div className="container-fluid">
            <style>
                {`
                /* Tắt màu nền xen kẽ (striped) và hiệu ứng hover mặc định của từng thẻ tr lẻ */
                .custom-group-table tbody tr > td {
                    background-color: #ffffff !important;
                    box-shadow: none !important;
                    transition: background-color 0.15s ease-in-out;
                }
                
                /* Khi hover vào bất kỳ vị trí nào trong tbody, tất cả thẻ td bên trong đều đổi màu xám */
                .custom-group-table tbody:hover tr > td {
                    background-color: #f5f6f8 !important; /* Màu xám nhạt */
                }
                `}
            </style>

            <Card style={{ borderRadius: '16px' }}>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Hồ sơ giấy phép hành nghề</h5>
                        <div className="d-flex">
                            {!isLoading && !isError && profileData && profileData.gphns.length === 0 && (
                                <NavLink to={URI_INTERNAL.GIAYPHEPHANHNGHE_CREATE_PATH} className="btn btn-success">
                                    Thêm mới
                                </NavLink>
                            )}
                        </div>
                    </div>
                </Card.Header>

                <Card.Body>
                    <div className="table-responsive">
                        <Table bordered className="align-middle custom-group-table" style={{ border: '1px solid #dee2e6' }}>
                            <thead className="table-light">
                                <tr>
                                    <th rowSpan="2" className="align-middle text-center" style={{ border: '1px solid #dee2e6', width: '50px', minWidth: '50px' }}>STT</th>
                                    <th rowSpan="2" className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '160px' }}>Họ và tên</th>

                                    {/* Cập nhật colSpan từ 8 lên 9 */}
                                    <th colSpan="9" className="align-middle text-center" style={{ border: '1px solid #dee2e6' }}>Giấy phép hành nghề</th>
                                    <th colSpan="3" className="align-middle text-center" style={{ border: '1px solid #dee2e6' }}>Văn bằng, Chứng chỉ chuyên khoa</th>

                                    <th rowSpan="2" className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '130px' }}>Xác nhận phạm vi hành nghề</th>
                                    <th rowSpan="2" className="align-middle text-center" style={{ border: '1px solid #dee2e6', width: '100px', minWidth: '100px' }}>Thao tác</th>
                                </tr>
                                <tr>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '110px' }}>Số giấy phép</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '80px' }}>Loại</th>

                                    {/* Đổi tên cột */}
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '150px' }}>Chức danh chuyên môn</th>

                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '160px' }}>Phạm vi hành nghề</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '110px' }}>Ngày cấp</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '110px' }}>Ngày hết hạn</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '130px' }}>Nơi cấp</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '100px' }}>File minh chứng</th>

                                    {/* Thêm cột mới */}
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '160px' }}>Chức danh đang hoạt động</th>

                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '160px' }}>Tên chứng chỉ</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '110px' }}>Ngày cấp</th>
                                    <th className="align-middle text-center" style={{ border: '1px solid #dee2e6', minWidth: '100px' }}>File minh chứng</th>
                                </tr>
                            </thead>

                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        {/* Cập nhật colSpan từ 15 lên 16 */}
                                        <td colSpan={16} className="text-center py-4" style={{ border: '1px solid #dee2e6' }}>Đang tải dữ liệu hồ sơ...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        {/* Cập nhật colSpan từ 15 lên 16 */}
                                        <td colSpan={16} className="text-center text-danger py-4" style={{ border: '1px solid #dee2e6' }}>
                                            Lỗi: {error?.message || 'Không tải được dữ liệu'}
                                        </td>
                                    </tr>
                                ) : !profileData || (profileData.gphns.length === 0 && profileData.cccms.length === 0) ? (
                                    <tr>
                                        {/* Cập nhật colSpan từ 15 lên 16 */}
                                        <td colSpan={16} className="text-center py-4" style={{ border: '1px solid #dee2e6' }}>Hồ sơ của bạn hiện chưa có dữ liệu</td>
                                    </tr>
                                ) : (
                                    (() => {
                                        const gphns = profileData.gphns || [];
                                        const cccms = profileData.cccms || [];
                                        const gLen = gphns.length;
                                        const cLen = cccms.length;
                                        const totalRows = Math.max(1, gLen, cLen);

                                        const getRowSpan = (idx, length) => {
                                            if (length === 0 && idx === 0) return totalRows;
                                            if (idx === length - 1) return totalRows - idx;
                                            return 1;
                                        };

                                        return Array.from({ length: totalRows }).map((_, i) => {
                                            const g = gphns[i];
                                            const cc = cccms[i];

                                            const showGphn = i < gLen || (gLen === 0 && i === 0);
                                            const gSpan = getRowSpan(i, gLen);

                                            const showCccm = i < cLen || (cLen === 0 && i === 0);
                                            const cSpan = getRowSpan(i, cLen);

                                            return (
                                                <tr key={i}>
                                                    {i === 0 && (
                                                        <>
                                                            <td rowSpan={totalRows} className="text-center align-middle" style={{ border: '1px solid #dee2e6' }}>1</td>
                                                            <td rowSpan={totalRows} className="align-middle text-center" style={{ border: '1px solid #dee2e6' }}>{profileData.name}</td>
                                                        </>
                                                    )}

                                                    {showGphn && (
                                                        <>
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? (g.soGiayPhep || g.SoGiayPhep || '-') : '-'}
                                                            </td>
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? (g.loaiGiayPhep ?? g.LoaiGiayPhep ?? '-') : '-'}
                                                            </td>

                                                            {/* Render dữ liệu: Chức danh chuyên môn */}
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? (profileData.chucDanhChuyenMon || '-') : '-'}
                                                            </td>

                                                            <td rowSpan={gSpan} className="align-middle" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? (() => {
                                                                    const pvhnList = getPvhnList(g);
                                                                    return pvhnList.length > 0 ? (
                                                                        <div style={{ textAlign: 'left' }}>
                                                                            {pvhnList.map((item, idx) => <div key={idx}>{item}</div>)}
                                                                        </div>
                                                                    ) : <div className="text-center">-</div>;
                                                                })() : <div className="text-center">-</div>}
                                                            </td>
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? formatDate(g.ngayCap || g.NgayCap) : '-'}
                                                            </td>
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? formatDate(g.ngayHetHan || g.NgayHetHan || g.thoiHan || g.ThoiHan) : '-'}
                                                            </td>
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? formatNoiCap(g.noiCap ?? g.NoiCap) : '-'}
                                                            </td>
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g && (g.fileMinhChungPath || g.FileMinhChungPath) ? (
                                                                    <Button variant="outline-info" size="sm" onClick={() => handleOpenFile(g.fileMinhChungPath || g.FileMinhChungPath)}>Xem</Button>
                                                                ) : '-'}
                                                            </td>

                                                            {/* Render dữ liệu cột mới: Chức danh đang hoạt động */}
                                                            <td rowSpan={gSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {g ? (profileData.chucDanh || '-') : '-'}
                                                            </td>
                                                        </>
                                                    )}

                                                    {showCccm && (
                                                        <>
                                                            <td rowSpan={cSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {cc ? (cc.tenChungChi || cc.TenChungChi || '-') : '-'}
                                                            </td>
                                                            <td rowSpan={cSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {cc ? formatDate(cc.ngayCap || cc.NgayCap) : '-'}
                                                            </td>
                                                            <td rowSpan={cSpan} className="align-middle text-center" style={{ border: '1px solid #dee2e6', padding: '12px' }}>
                                                                {cc && (cc.fileMinhChungPath || cc.FileMinhChungPath) ? (
                                                                    <Button variant="outline-info" size="sm" onClick={() => handleOpenFile(cc.fileMinhChungPath || cc.FileMinhChungPath)}>Xem</Button>
                                                                ) : '-'}
                                                            </td>
                                                        </>
                                                    )}

                                                    {i === 0 && (
                                                        <>
                                                            <td rowSpan={totalRows} className="align-middle text-center" style={{ border: '1px solid #dee2e6' }}>
                                                                {(() => {
                                                                    const currentStatus = profileData.xacNhanStatus;
                                                                    let label = '', colorClass = '';
                                                                    if (currentStatus === "Nhập liệu" || currentStatus === null || currentStatus === undefined) {
                                                                        label = 'Nhập liệu'; colorClass = 'bg-secondary';
                                                                    } else if (currentStatus === "Chờ duyệt") {
                                                                        label = 'Chờ duyệt'; colorClass = 'bg-warning text-dark';
                                                                    } else if (currentStatus === "Đã duyệt") {
                                                                        label = 'Đã duyệt'; colorClass = 'bg-success';
                                                                    } else if (currentStatus === "Từ chối") {
                                                                        label = 'Từ chối'; colorClass = 'bg-danger';
                                                                    } else {
                                                                        const fallback = formatTrangThai(currentStatus);
                                                                        label = fallback.label; colorClass = fallback.color;
                                                                    }

                                                                    return (
                                                                        <div className="d-flex flex-column align-items-center">
                                                                            <span className={`badge ${colorClass}`} style={{ padding: '8px 12px', fontSize: '13px', fontWeight: '500' }}>{label}</span>

                                                                            {(label === 'Từ chối' || label === 'Không phù hợp') && profileData.lyDo && (
                                                                                <div className="text-danger mt-1 fst-italic" style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                                                                                    ({profileData.lyDo})
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </td>
                                                            <td rowSpan={totalRows} className="align-middle text-center" style={{ border: '1px solid #dee2e6' }}>
                                                                {profileData.gphns.length > 0 ? (
                                                                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ gap: '8px' }}>
                                                                        <NavLink className="btn btn-primary btn-sm w-100" to={`${URI_INTERNAL.GIAYPHEPHANHNGHE_EDIT_PATH}?id=${profileData.gphns[0].id || profileData.gphns[0].Id}`}>
                                                                            Sửa
                                                                        </NavLink>
                                                                        {!hideSubmitButton && (
                                                                            <Button
                                                                                variant="success"
                                                                                size="sm"
                                                                                className="w-100"
                                                                                disabled={isSubmitting}
                                                                                onClick={() => openConfirmGuiXacNhan(profileData.gphns[0].id || profileData.gphns[0].Id)}
                                                                            >
                                                                                {isSubmitting ? 'Đang gửi...' : 'Gửi xác nhận'}
                                                                            </Button>
                                                                        )}
                                                                    </div>
                                                                ) : <span className="text-muted">-</span>}
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        });
                                    })()
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {/* Thêm phần render ConfirmModal */}
                    <ConfirmModal
                        isOpen={openConfirmModal}
                        confirmType="confirm"
                        handleAccept={acceptGuiXacNhan}
                        handleCancel={cancelGuiXacNhan}
                        content="Bạn có chắc chắn muốn gửi xác nhận hồ sơ này?"
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default GiayPhepHanhNghe;